import { ECHARTSCOLOR } from '@intelligence/utils/echartsConst';

/**
 * 柱状图颜色序列
 */
export const BAR_CHART_COLORS = ECHARTSCOLOR;

/**
 * 柱子宽度（null表示自适应）
 */
export const BAR_WIDTH = null;

/**
 * 柱子最大宽度
 */
export const BAR_MAX_WIDTH = 60;

/**
 * 柱子最小宽度
 */
export const BAR_MIN_WIDTH = 10;

/**
 * 高亮背景色
 */
export const HIGHLIGHT_BG_COLOR = 'rgba(50, 111, 240, 0.08)';

/**
 * 网格配置（带顶部标签）
 * containLabel: true 确保Y轴标签不被裁剪
 */
export const BAR_GRID_WITH_LABEL = {
  left: 10,
  right: 10,
  top: 20,
  bottom: 0,
  containLabel: true,
};

/**
 * 网格配置（无顶部标签）
 */
export const BAR_GRID_WITHOUT_LABEL = {
  left: '10px',
  right: '10px',
  top: '20px',
  // bottom: '10px',
  bottom: 0,
  containLabel: true,
};

/**
 * echarts柱状图静态配置
 */
export const BAR_CHART_STATIC_OPTION: any = {
  color: BAR_CHART_COLORS,
  title: {
    show: false,
  },
  tooltip: {
    trigger: 'axis',
    padding: 0,
    borderWidth: 0,
    backgroundColor: 'rgba(255, 255, 255, 0)',
    confine: true,
    hideDelay: 200,
    triggerOn: 'mousemove',
    axisPointer: {
      type: 'shadow',
    },
  },
  legend: {
    show: false,
  },
  grid: BAR_GRID_WITH_LABEL,
  xAxis: {
    type: 'category',
    axisTick: {
      alignWithLabel: true,
      lineStyle: {
        color: '#BFBFBF',
        width: 1,
      },
    },
    axisLine: {
      show: true,
      lineStyle: {
        color: '#BFBFBF',
        width: 1,
      },
    },
    boundaryGap: true,
    axisLabel: {
      interval: 0,
      color: '#000',
      align: 'center',
      opacity: 0.45,
      fontSize: 12,
      margin: 20,
    },
    data: [],
  },
  yAxis: [
    {
      type: 'value',
      axisLabel: {
        color: '#838697',
        fontSize: 12,
      },
      splitLine: {
        lineStyle: {
          type: 'dashed',
          color: '#E5E5E5',
        },
      },
      show: true,
    },
  ],
  series: [],
};
